'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import CustomImage from '@components/CustomImage';
import SplideSlider from '@components/SplideSlider';
import cn from './style.module.scss';
export default function EastvaleLocation(props: MarketingPageComponentProps) {
  const locationSection = props?.locale?.section?.find(
    (section: any) => section.type === 'location' && section.enabled
  );
  if (!locationSection) return null;
  const locationSliderData = locationSection?.eastvaleLocationSlider ?? [];
  const eastvaleLocationSettings = {
    type: 'loop',
    autoplay: true,
    rewind: true,
    speed: 1000,
    interval: 3000,
  };
  return (
    <Stack component="section" className={cn.eastvaleLocationWrapper}>
      <Box className={cn.eastvaleLocationBlock}>
        <Box className={cn.eastvaleLocationStory}>
          <SplideSlider options={eastvaleLocationSettings}>
            {locationSliderData.map((item: any, index: number) => (
              <Box className={cn.eastvaleLocationElement} key={index}>
                <CustomImage
                  src={item.url}
                  alt={item.alt}
                  width={768}
                  height={768}
                />
              </Box>
            ))}
          </SplideSlider>
        </Box>
      </Box>
    </Stack>
  );
}
